import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const taskVuex = createNamespacedHelpers("task");
const userVuex = createNamespacedHelpers("user");
import vailcode from "@utils/errcode";
export default {
  name: "turn",
  computed: {
    ...taskVuex.mapState(["taskInfo"]),
    ...userVuex.mapState(["userInfo", "balanceInfo"])
  },
  data() {
    return {
      luckyInfo: null,
      prizeList: null,
      prizeIndex: 0,
      isBtnLoading: false,
      prizeAllResult: null,
      isResultAnim: false,
      isPageLoading: true,
      isRefresh: false,
      popStockEnoughShow: false,
      selectCountOptions: 1,
      //当前选择的倍数
      countStep: 0,
      //当前选择倍数在列表中的索引值
      deductionSpins: 1,
      //每次扣除老虎机条数(含倍数)
      isMultipleInfoShow: false,
      multipleInfoShowTimer: null,
      count_options: [] //倍数列表
    };
  },

  watch: {
    "taskInfo.popReward.isEnd": {
      handler(bool) {
        if (!bool) return;
        if (this.deductionSpins >= this.userInfo.stock) {
          this.countStep = this.count_options.findIndex(item => this.userInfo.stock >= item * this.luckyInfo.price_stock);
        }
        this.selectCountOptions = this.count_options[this.countStep >= 0 ? this.countStep : this.count_options.length - 1];
        this.deductionSpins = this.luckyInfo.price_stock * this.selectCountOptions;
      },
      deep: true
    }
  },
  methods: {
    setActivityConfig() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/lucky/lottery/list", {
          provider: "official",
          type: 0
        });
        // const res = {
        //   code: 0,
        //   message: "",
        //   data: [],
        // };
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          if (data.length <= 0) {
            this.luckyInfo = {};
          } else {
            this.luckyInfo = data[0];
            this.count_options = this.luckyInfo.count_options.sort((a, b) => b - a);
            if (this.count_options && this.count_options.length > 0) {
              this.countStep = this.count_options.findIndex(item => this.userInfo.stock >= item * this.luckyInfo.price_stock);
              this.selectCountOptions = this.luckyInfo.count_options[this.countStep >= 0 ? this.countStep : this.count_options.length - 1];
              this.deductionSpins = this.luckyInfo.price_stock * this.selectCountOptions;
            }
          }
          resolve(this.luckyInfo);
        }, () => {
          resolve();
        });
      });
    },
    setLuckyList() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/lucky/lottery/items", {
          lotteryId: this.luckyInfo.id
        });
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          if (data.length <= 0) {
            resolve();
            return;
          }
          this.prizeList = [];
          data.forEach((item, index) => {
            this.prizeList.push({
              id: item.id,
              value: item.amount,
              type: item.currency
            });
          });
          console.log("this.prizeListthis.prizeList", this.prizeList);
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    getLuckyResult() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/lucky/lottery/draw", {
          lotteryId: this.luckyInfo.id,
          count: this.selectCountOptions
        });
        // const res = await _v.$http.post("/lucky/lottery/draw", { lotteryId: this.luckyInfo.id, count: 1000 });
        if (res.code == 0) {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          if (!data) {
            this.$toasted.clear();
            this.$toasted.error(res.message);
            resolve();
            return;
          }
          resolve(data);
        } else {
          if (res.code === 404) {
            this.initFnc();
            resolve();
            return;
          }
          this.$toasted.clear();
          this.$toasted.error(res.message);
        }
      });
    },
    async initFnc() {
      this.isPageLoading = true;
      const config = await this.setActivityConfig();
      if (!config) {
        this.isRefresh = false;
        return;
      }
      const items = await this.setLuckyList();
      if (!items) {
        this.isRefresh = false;
        return;
      }
      this.isPageLoading = false;
      console.log("itemsitemsitemsitemsitems", items);
    },
    async onStart() {
      if (this.isBtnLoading) return;
      if (this.userInfo.stock < this.deductionSpins) {
        console.log("luckyInfo?.price_stock");
        this.popStockEnoughShow = true;
        this.isBtnLoading = false;
        return;
      }
      const vueLuckywheel = this.$refs.vueLuckywheel;
      if (!vueLuckywheel) {
        this.isBtnLoading = false;
        return;
      }
      this.isBtnLoading = true;
      const res = await this.getLuckyResult();
      this.setStockFloatNumber(this.deductionSpins, "-");
      this.userInfo.stock -= this.deductionSpins;
      if (!res) {
        this.isBtnLoading = false;
        return;
      }
      this.prizeAllResult = res;
      this.prizeIndex = this.prizeList.findIndex(item => {
        return item.id === res.winning_item.id;
      });
      console.log("this.prizeIndex", this.prizeIndex);
      if (this.prizeIndex == -1) {
        this.userInfo.stock += this.deductionSpins;
        this.isBtnLoading = false;
        return;
      }
      this.$nextTick(vueLuckywheel.draw);
    },
    async onResult() {
      this.isResultAnim = true;
      await new Promise(resolve => setTimeout(resolve, 800));
      this.isResultAnim = false;
      // this.taskInfo.popReward.reward = this.prizeAllResult.winning_item.amount;
      // this.taskInfo.popReward.icon = this.prizeAllResult.winning_item.currency == "TICKET" ? "PASS" : this.prizeAllResult.winning_item.currency;
      // this.taskInfo.popReward.userInfo = this.prizeAllResult.user;
      // this.taskInfo.popReward.show = true;
      let gameReward = {};
      const winning_item = this.prizeAllResult.winning_item;
      //       const winning_item = {amount:12598123.0001234,count:1,
      // currency: "USDT",disp_combo: [],icon: "",unit_amount:0.001};
      gameReward[`${winning_item.currency.toLowerCase()}`] = winning_item.amount;
      this.taskInfo.popReward.reward = gameReward;
      this.taskInfo.popReward.icon = "MORE";
      this.taskInfo.popReward.userInfo = this.prizeAllResult.user;
      // this.setUserInfo({ ...this.prizeAllResult.user });
      this.taskInfo.popReward.show = true;
      this.isBtnLoading = false;
    },
    async selectMultiple() {
      if (this.isBtnLoading) return;
      const machineMultipleRef = this.$refs.machineMultipleRef;
      if (!machineMultipleRef) return;
      this.countStep++;
      clearTimeout(this.multipleInfoShowTimer);
      if (this.userInfo.stock < this.count_options[this.countStep] * this.luckyInfo.price_stock || this.count_options.length <= this.countStep) {
        this.countStep = this.count_options.findIndex(item => this.userInfo.stock >= item * this.luckyInfo.price_stock);
      }
      this.selectCountOptions = this.count_options[this.countStep >= 0 ? this.countStep : this.count_options.length - 1];
      console.log("this.countStep", this.countStep, this.selectCountOptions);
      this.deductionSpins = this.luckyInfo.price_stock * this.selectCountOptions;
      //按钮点击效果
      machineMultipleRef.classList.add("active");
      setTimeout(() => {
        machineMultipleRef.classList.remove("active");
      }, 150);
      //倍数提示窗口
      if (this.selectCountOptions <= 1) {
        this.isMultipleInfoShow = false;
        return;
      } //1倍不弹出 奖励倍数弹窗
      this.isMultipleInfoShow = true;
      this.multipleInfoShowTimer = setTimeout(() => {
        this.isMultipleInfoShow = false;
      }, 3000);
      console.dir(machineMultipleRef);
    },
    async onRefresh() {
      this.isRefresh = true;
      await this.initFnc();
    }
  },
  mounted() {
    this.$nextTick(async () => {
      this.setWowAnim();
      await this.initFnc();
    });
  }
};